import React from 'react';
import {Col, Divider, Row} from "antd";
import {CodeTag} from "../Boilerplate/CodeTag";
import AddressLink from "../AddressLink";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading2, withTransparentLoading} from "../Boilerplate/deferLoaderHoc";
import {getCompanyByShortName, getMyCompany} from "../../actions/companies";
import Spinner from "react-spinkit";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import ComponentNotFound from "../Boilerplate/ComponentNotFound";

const _CompanyProfileDisplay = props => {
  const { company: { resource: company } = {} } = props;
  if (!company) return <ComponentNotFound resource='company'/>;
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth-keyWidth;
  return <React.Fragment>
    <Divider><h1>General</h1></Divider>
    <Row className='key-value'>
      <Col span={keyWidth}>Company Name</Col>
      <Col span={valWidth}>{company.companyname}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Company Type</Col>
      <Col span={valWidth}>{company.companytype}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Address</Col>
      <Col span={valWidth}>
        <AddressLink address={{
          street: [company.address, company.address2].join('\n'),
          city: company.city,
          state: company.state,
          zip: company.zip
        }}/>
      </Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Phone</Col>
      <Col span={valWidth}>{company.phone}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Fax</Col>
      <Col span={valWidth}>{company.fax}</Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Email</Col>
      <Col span={valWidth}><a href={`mailto:${company.email}`}>{company.email}</a></Col>
    </Row>
    <Row className='key-value'>
      <Col span={keyWidth}>Website</Col>
      <Col span={valWidth}><a href={company.website}>{company.website}</a></Col>
    </Row>
    <Divider><h1>Services</h1></Divider>
    <Divider>CSI Codes</Divider>
    <Row>
      <Col span={rowWidth}>
        {company.csicodes && company.csicodes.map(code => <CodeTag table='csi' key={code} code={code}/>)}
      </Col>
    </Row>
    <Divider>Industries</Divider>
    <Row>
      <Col span={rowWidth}>
        {company.industries && company.industries.map(code => <CodeTag table='industry' key={code} code={code}/>)}
      </Col>
    </Row>
    <Divider>Sectors</Divider>
    <Row>
      <Col span={rowWidth}>
        {company.sectors && company.sectors.map(code => <CodeTag table='sector' key={code} code={code}/>)}
      </Col>
    </Row>
  </React.Fragment>;
};

_CompanyProfileDisplay.propTypes = {};

const myCompany = createSelector(
  state => state.profile.companyid,
  state => state.companies.data,
  (companyId, companies) => companies[companyId]
);

const companyByUrl = createSelector(
  (_, props) => props.match.params.company,
  state => state.companies.indexes,
  state => state.companies.data,
  (companyName, companyIndexes, companies) => companies[companyIndexes[companyName.toLocaleLowerCase()]]
);

export const PublicCompanyProfileDisplay = compose(
  connect(
    (state, props) => {
      let company = companyByUrl(state, props);
      return { company };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyByShortName(props.match.params.company))
    })
  ),
  withTransparentLoading
)(_CompanyProfileDisplay);

export const CompanyProfileDisplay = compose(
  connect(
    (state, props) => {
      let company = myCompany(state, props);
      return {
        company,
      };
    },
  ),
  withLoading2(
    (_, dispatch) => dispatch(getMyCompany()),
    () => <Spinner name='line-scale'/>,
    null,
    ['company']
  )
)(_CompanyProfileDisplay);




// WEBPACK FOOTER //
// ./src/components/Settings/CompanyProfileDisplay.js